import React from 'react'
import APIConfigurationMarkupFlight from './Flight/APIConfigurationMarkupFlight';
import APIConfigurationMarkupHotel from './Hotel/APIConfigurationMarkupHotel';
import APIMarkupForActivities from './Activities/APIMarkupForActivities';

const APIConfigurationMarkup = ({ useradd, useredit, userexport, toggleSequencing }) => {
    return (
        <>
            <div className="container-fluid my-2">
                <div className='container mt-3 mb-2 tab_section px-0'>
                    <ul className="nav nav-pills nav-justified mb-3 pt-3 col-lg-4 col-12 mx-auto" id="pills-tab" role="tablist">
                        <li className="nav-item mt-1 mx-1" role="presentation">
                            <button
                                type="button"
                                className="nav-link active"
                                id="pills-Flights-tab"
                                data-bs-toggle="pill"
                                onClick={() => toggleSequencing('.API-configuration-markup-for-hotel')}
                                data-bs-target="#pills-Flightsmark"
                                role="tab" aria-controls="pills-Flights"
                                aria-selected="true">
                                <strong>Flights</strong>
                            </button>
                        </li>
                        <li className="nav-item mt-1 mx-1" role="presentation" >
                            <button
                                type="button"
                                className="nav-link API-configuration-markup-for-hotel"
                                id="pills-Hotel-tab"
                                data-bs-toggle="pill"
                                onClick={() => toggleSequencing('.API-configuration-markup-for-hotel')}
                                data-bs-target="#pills-Hotelsmark"
                                role="tab" aria-controls="pills-Hotel"
                                aria-selected="false">
                                <strong >Hotels</strong>
                            </button>
                        </li>

                        <li className="nav-item mt-1 mx-1" role="presentation" >
                            <button
                                type="button"
                                className="nav-link API-configuration-markup-for-hotel"
                                id="pills-Activities-tab"
                                data-bs-toggle="pill"
                                onClick={() => toggleSequencing('.API-configuration-markup-for-Activities')}
                                data-bs-target="#pills-Activities"
                                role="tab" aria-controls="pills-Activities"
                                aria-selected="false">
                                <strong >Activities</strong>
                            </button>
                        </li>
                    </ul>
                </div>
                <div className="tab-content" id="pills-tabContent">
                    <div
                        className="tab-pane fade show active"
                        id="pills-Flightsmark"
                        role="tabpanel"
                        aria-labelledby="pills-Flightsmark-tab"
                    >
                        <APIConfigurationMarkupFlight useradd={useradd} useredit={useredit} userexport={userexport} />
                    </div>

                    <div
                        className="tab-pane fade show"
                        id="pills-Hotelsmark"
                        role="tabpanel"
                        aria-labelledby="pills-Hotelsmark-tab"
                    >
                        <APIConfigurationMarkupHotel useradd={useradd} useredit={useredit} userexport={userexport} />
                    </div>
                    
                    <div
                        className="tab-pane fade show"
                        id="pills-Activities"
                        role="tabpanel"
                        aria-labelledby="pills-Activities-tab"
                    >
                        <APIMarkupForActivities useradd={useradd} useredit={useredit} userexport={userexport} />
                    </div>
                </div>
            </div>
        </>
    )
}

export default APIConfigurationMarkup